import { render } from "./QueryDetail.vue?vue&type=template&id=4180b4e9&scoped=true&ts=true"
import script from "./QueryDetail.vue?vue&type=script&lang=ts"
export * from "./QueryDetail.vue?vue&type=script&lang=ts"

import "./QueryDetail.vue?vue&type=style&index=0&id=4180b4e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4180b4e9"]])

export default __exports__